import { apiGetWithFallback, wpRestRoute } from 'utils';

// ProfessionalPosition (cargos) — antes vivia no MySQL do core (StaPortalDb).
// Agora é servido por endpoint nativo do WordPress (namespace sta/v1), que
// mantém o mesmo formato { id, description }. A leitura vai por ?rest_route=
// para não depender do behavior wp-json/sta/v1 do CloudFront.
export const getProfessionalPositionList = async (params) => {
    try {
        const { data } = await apiGetWithFallback(wpRestRoute('/sta/v1/professional-positions'), params)
        return data || [];
    } catch (error) {
        return [];
    }
}
